import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis,
  CartesianGrid, Tooltip, Legend, Cell
} from 'recharts';
import { Card, CardText, Button } from "react-bootstrap";

const data = [
  { film: "John Wick",      domestic: 43,   international: 45  },
  { film: "The Equalizer",  domestic: 101,  international: 91  },
  { film: "Limitless",      domestic: 79,   international: 82  },
  { film: "Upgrade",        domestic: 9,    international: 7   },
  { film: "Falling Down",   domestic: 23,   international: 18  },
];

export default function DomesticVsInternational() {
  return (
    <div style={{ width: "100%", display: "flex", gap: "1rem", }}>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "1rem", minHeight: 0, }}>
        <h11 style={{ color: 'white', textAlign: 'center', marginBottom: '0rem' }}>
           Domestic vs. International Box Office — Action Films (USD Millions)
        </h11>
   <ul style={{ color: "white", margin: 0, paddingLeft: '1.2rem', lineHeight: '1.8' }}>
  <li>Domestic and international box office are nearly evenly split across comps — <strong>$255M domestic</strong> vs. <strong>$243M international</strong>, a <strong>51/49 balance</strong> overall.</li>
  <li><strong>John Wick</strong> and <strong>Limitless</strong> lean international, each earning more overseas than at home.</li>
  <li><strong>Upgrade</strong> and <strong>Falling Down</strong> skew domestic, pulling roughly <strong>25–30% more</strong> revenue stateside.</li>
  <li>The near-even split signals strong <strong>international distribution potential</strong> for a well-positioned action property.</li>
</ul>
        </div>

  
     <div style={{ flex: 1, position: "relative", minHeight: 0 }}>
          <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 10, right: 5, left: -10, bottom: -10 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
          <XAxis
            dataKey="film"
            tick={{ fill: '#fff', fontSize: 14 }}
            stroke="rgba(255,255,255,0.3)"
            angle={-25}
            textAnchor="end"
            interval={0}
             height={60}  
          />
          <YAxis
            tickFormatter={(v) => `$${v}M`}
            tick={{ fill: '#fff', fontSize: 14 }}
            stroke="rgba(255,255,255,0.3)"
          />
          <Tooltip
          cursor={{ fill: 'rgba(243, 174, 61, 0.1)' }}
            formatter={(value, name) => [`$${value}M`, name]}
            contentStyle={{
              backgroundColor: 'rgba(20,19,19,0.9)',
              border: '1px solid rgba(243,174,61,0.4)',
              borderRadius: '8px',
              color: '#fff',
            }}
          />
          <Legend wrapperStyle={{ color: '#fff' }}
          style={{
            marginTop: '1rem',
          }} />
          <Bar dataKey="domestic" name="Domestic" fill="rgb(244, 236, 222, .35)" radius={[4, 4, 0, 0]} />
          <Bar dataKey="international" name="International" fill="rgba(179, 37, 25, 0.85)" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>

     </div>


 

    </div>
  );
}